import VideoDataGetter from './container'
export default VideoDataGetter
